module.exports = __webpack_public_path__ + "img/imagen2.208c5f13.png";